import { render, staticRenderFns } from "./aliPay.vue?vue&type=template&id=b1fd37ac"
import script from "./aliPay.vue?vue&type=script&lang=js"
export * from "./aliPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports